/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReinsuredResponseDto
 */
export interface ReinsuredResponseDto {
    /**
     * 
     * @type {Date}
     * @memberof ReinsuredResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ReinsuredResponseDto
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof ReinsuredResponseDto
     */
    reinsuredId: string;
    /**
     * 
     * @type {string}
     * @memberof ReinsuredResponseDto
     */
    status: ReinsuredResponseDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ReinsuredResponseDto
     */
    reinsuredGroup: ReinsuredResponseDtoReinsuredGroupEnum;
    /**
     * 
     * @type {string}
     * @memberof ReinsuredResponseDto
     */
    legalEntityName: string;
    /**
     * 
     * @type {string}
     * @memberof ReinsuredResponseDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ReinsuredResponseDto
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof ReinsuredResponseDto
     */
    country: string;
    /**
     * 
     * @type {string}
     * @memberof ReinsuredResponseDto
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof ReinsuredResponseDto
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof ReinsuredResponseDto
     */
    postcode?: string;
}


/**
 * @export
 */
export const ReinsuredResponseDtoStatusEnum = {
    Active: 'Active',
    Inactive: 'Inactive'
} as const;
export type ReinsuredResponseDtoStatusEnum = typeof ReinsuredResponseDtoStatusEnum[keyof typeof ReinsuredResponseDtoStatusEnum];

/**
 * @export
 */
export const ReinsuredResponseDtoReinsuredGroupEnum = {
    Aig: 'AIG',
    Allianz: 'Allianz',
    ArabiaInsurance: 'Arabia Insurance',
    AxaXl: 'AXA XL',
    BangkokInsurance: 'Bangkok Insurance',
    Captive: 'Captive',
    Chubb: 'Chubb',
    FalconInsurance: 'Falcon Insurance',
    Fubon: 'Fubon',
    HdiGlobal: 'HDI Global',
    Hollard: 'Hollard',
    HyundaiInsurance: 'Hyundai Insurance',
    KbInsurance: 'KB Insurance',
    MitsuiSumitomo: 'Mitsui Sumitomo',
    NewIndia: 'New India',
    OmanInsurance: 'Oman Insurance',
    Other: 'Other',
    Samsung: 'Samsung',
    Scor: 'SCOR',
    Sompo: 'SOMPO',
    Starr: 'Starr',
    TokioMarine: 'Tokio Marine',
    Vero: 'Vero',
    Zurich: 'Zurich'
} as const;
export type ReinsuredResponseDtoReinsuredGroupEnum = typeof ReinsuredResponseDtoReinsuredGroupEnum[keyof typeof ReinsuredResponseDtoReinsuredGroupEnum];


/**
 * Check if a given object implements the ReinsuredResponseDto interface.
 */
export function instanceOfReinsuredResponseDto(value: object): value is ReinsuredResponseDto {
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('reinsuredId' in value) || value['reinsuredId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('reinsuredGroup' in value) || value['reinsuredGroup'] === undefined) return false;
    if (!('legalEntityName' in value) || value['legalEntityName'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    return true;
}

export function ReinsuredResponseDtoFromJSON(json: any): ReinsuredResponseDto {
    return ReinsuredResponseDtoFromJSONTyped(json, false);
}

export function ReinsuredResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReinsuredResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'reinsuredId': json['reinsuredId'],
        'status': json['status'],
        'reinsuredGroup': json['reinsuredGroup'],
        'legalEntityName': json['legalEntityName'],
        'name': json['name'],
        'address': json['address'] == null ? undefined : json['address'],
        'country': json['country'],
        'city': json['city'] == null ? undefined : json['city'],
        'state': json['state'] == null ? undefined : json['state'],
        'postcode': json['postcode'] == null ? undefined : json['postcode'],
    };
}

export function ReinsuredResponseDtoToJSON(json: any): ReinsuredResponseDto {
    return ReinsuredResponseDtoToJSONTyped(json, false);
}

export function ReinsuredResponseDtoToJSONTyped(value?: ReinsuredResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'reinsuredId': value['reinsuredId'],
        'status': value['status'],
        'reinsuredGroup': value['reinsuredGroup'],
        'legalEntityName': value['legalEntityName'],
        'name': value['name'],
        'address': value['address'],
        'country': value['country'],
        'city': value['city'],
        'state': value['state'],
        'postcode': value['postcode'],
    };
}

